import { Injectable, inject } from '@angular/core';
import { Firestore, doc, setDoc, getDoc, collection, getDocs } from '@angular/fire/firestore';
import { from, Observable } from 'rxjs';

export interface User {
  uid: string;
  displayName: string;
  photoURL?: string;
  bio?: string;
  joinedAt?: string;
  location?: string;
}

@Injectable({ providedIn: 'root' })
export class UserService {
  private firestore = inject(Firestore);

  /** 🔹 Crear o actualizar usuario en Firestore */
  saveUser(user: User): Observable<void> {
    return from(
      (async () => {
        const ref = doc(this.firestore, `users/${user.uid}`);
        await setDoc(ref, { ...user }, { merge: true });
        console.log('✅ Usuario guardado/actualizado:', user.displayName);
      })()
    );
  }

  /** 🔹 Obtener usuario por ID */
  getUserById(uid: string): Observable<User | null> {
    return from(
      (async () => {
        const ref = doc(this.firestore, `users/${uid}`);
        const snap = await getDoc(ref);
        if (!snap.exists()) {
          console.warn('⚠️ Usuario no encontrado:', uid);
          return null;
        }
        console.log('📄 Usuario Firestore:', snap.data());
        return snap.data() as User;
      })()
    );
  }

  /** 🔹 Obtener todos los usuarios */
  getAllUsers(): Observable<User[]> {
    return from(
      (async () => {
        const ref = collection(this.firestore, 'users');
        const snaps = await getDocs(ref);
        const all = snaps.docs.map(d => d.data() as User);
        console.log('👥 Todos los usuarios:', all);
        return all;
      })()
    );
  }
}
